import React from 'react'
import { connect } from 'react-redux'
import { Modal, Row, Col, Button } from 'react-bootstrap'

import ChartCard from './ChartCard'

import { setChartToForm } from '../reducers/chartFormReducer'

const IncompleteChartsModal = (props) => {

  const { show, incompleteCharts, routerProps } = props

  const handleChartCardClick = (chart) => {
    props.setChartToForm(chart)
    if (routerProps.location.pathname !== '/charts/new') {
      props.routerProps.history.push('/charts/new')
    }
  }
  
  return (
    <Modal
      show={show} 
      onHide={props.toggleShow} 
      dialogClassName="modal-wide"
    >
      <Modal.Header closeButton>
        {incompleteCharts.length > 0 ?
         "You have incomplete charts"
         :
         "You have no incomplete charts" 
        }
      </Modal.Header>

      <Modal.Body>
        {incompleteCharts.length > 0 ?
          <Row>
            {incompleteCharts.map(chart => {
              return (
                <Col key={chart.id} xs={12} sm={12} md={6} lg={6}>
                  <ChartCard
                    style={{display: 'inline-block'}}
                    chart={chart}
                    chartViewButtonText="Continue Data Entry"
                    onClick={() => handleChartCardClick(chart)}
                  />
                </Col>
              )
            })}
          </Row>
         :
         <center>
           <h5>
             There are no incomplete charts to display
           </h5>
         </center>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={props.toggleShow} variant="secondary">Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    incompleteCharts: state.chartsReducer.incompleteCharts,
  }
}

const mapDispatchToProps = {
    setChartToForm
}


export default connect(mapStateToProps, mapDispatchToProps)(IncompleteChartsModal)
